var kind          = require("enyo/kind"),
    quickMacroize = require("enyo/macroize").quickMacroize;

require("./VimeoBackground.less");

module.exports = kind(/** @lends app.ui.VimeoBackground.prototype */ {

    /**
     * @private
     */
    name: "app.ui.VimeoBackground",

    /**
     * @private
     */
    classes: "app-ui-vimeo-background enyo-fit",

    /**
     * @private
     */
    components: [{
        name:       "iframe",
        classes:    "app-ui-vimeo-background-iframe",
        tag:        "iframe",
        attributes: {
            allow:           "autoplay",
            allowfullscreen: ""
        }
    }],

    /**
     * @type  {?string}
     * @public
     */
    videoId: null,

    /**
     * @method
     * @private
     */
    aspectRatio: null,

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.videoIdChanged();
        };
    }),

    /**
     * @protected
     */
    videoIdChanged: function() {
        var videoId = this.get("videoId"),
            src;

        // No video, no need to show
        if (!videoId) {
            this.hide();
            this.$.iframe.setAttribute("src", null);

            return;
        }

        src = quickMacroize("https://player.vimeo.com/video/{$videoId}?transparent=0&background=1&dnt=1", {
            videoId: videoId
        });

        this.$.iframe.setAttribute("src", src);
        this.show();
    },

    /**
     * @private
     */
    aspectRatioChanged: function() {
        this.reflow();
    },

    /**
     * @private
     */
    reflow: kind.inherit(function(sup) {
        return function() {
            var bounds,
                containerRatio,
                videoRatio = this.get("aspectRatio");

            sup.apply(this, arguments);

            bounds         = this.getBounds();
            containerRatio = bounds.width / bounds.height;

            // Scaling the video to the width of the container will make it as
            // tall or taller than the container
            if (videoRatio <= containerRatio) {
                this.$.iframe.setBounds({
                    width:  bounds.width + "px",
                    height: (bounds.width / videoRatio) + "px"
                });
            }

            // Scaling the video to the height of the container will make it as
            // wide or wider than the container.
            else {
                this.$.iframe.setBounds({
                    width:  (bounds.height * videoRatio) + "px",
                    height: bounds.height + "px"
                });
            }
        };
    })

});
